module.exports = __webpack_public_path__ + "static/media/stormtrooper.9127a99e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stormtrooper.jpg
// module id = 43
// module chunks = 0